





































































































































































































































































































































































































import {defineComponent, ref, onMounted, onBeforeUnmount, watch} from '@nuxtjs/composition-api';
import {getMetaInfo} from "~/helpers/getMetaInfo";
import LoadWhenVisible from '~/components/utils/LoadWhenVisible.vue';
import Carousel from "~/components/togas/Carousel.vue";
import SfButton from "~/components/atoms/SfButton/SfButton.vue";
import SfLink from "~/components/atoms/SfLink/SfLink.vue";
import {SfIcon} from "~/components";
import { useWebsiteCode } from '~/composables';
import { localizeBannerUrl } from '~/utilities/helpers/localize-banner-url';
import Swiper, {Navigation, Pagination} from 'swiper';

Swiper.use([Navigation, Pagination]);

export default defineComponent({
  name: 'Odeon',
  methods: { localizeBannerUrl },
  components: {
    LoadWhenVisible,
    SfIcon,
    SfLink,
    SfButton,
    Carousel,
    PresentationProduct: () => import('~/components/togas/PresentationProduct.vue'),
    Anniversary100: () => import('~/components/togas/Anniversary100.vue'),
  },
  head() {
    return getMetaInfo({
      metaTitle: 'Коллекция Одеон — 100 лет Togas',
      metaDescription: 'Архитектурная поэма уюта. Лимитированная коллекция Одеон к столетию Togas, вдохновленная наследием Эллады.',
    });
  },
  setup() {
    const { isRu } = useWebsiteCode();
    const isMobile = ref(false);
    const isPlaying = ref(false);
    const videoRef = ref<HTMLVideoElement | null>(null);
    const videoContainerRef = ref<HTMLElement | null>(null);
    let observer: IntersectionObserver | null = null;

    const carouselSettings = {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
      loop: true,
      loopedSlides: 3,
      loopAdditionalSlides: 3,
      longSwipesRatio: 0.1,
      longSwipesMs: 200,
      followFinger: true,
      touchReleaseOnEdges: false,
      freeMode: false,
      resistanceRatio: 0,
      speed: 800,
      grabCursor: true,
      watchSlidesProgress: true,
      breakpoints: {
        0: {slidesPerView: 1, slidesPerGroup: 1},
        480: {slidesPerView: 1, slidesPerGroup: 1},
        768: {slidesPerView: 1, slidesPerGroup: 1},
        1024: {slidesPerView: 1, slidesPerGroup: 1},
        1366: {slidesPerView: 1, slidesPerGroup: 1},
        1920: {slidesPerView: 1, slidesPerGroup: 1},
      },
    };

    const getActiveVideo = (): HTMLVideoElement | null => {
      return videoRef.value;
    };

    const togglePlay = () => {
      const video = getActiveVideo();
      if (!video) return;
      video.paused ? video.play().catch(() => {}) : video.pause();
    };

    const handleVisibility = (entries: IntersectionObserverEntry[]) => {
      const entry = entries[0];
      if (!entry) return;
      const video = getActiveVideo();
      if (!video) return;
      entry.isIntersecting ? video.play().catch(() => {}) : video.pause();
    };

    const setupObserver = () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (!videoContainerRef.value) return;
      observer = new IntersectionObserver(handleVisibility, {
        threshold: 0,
        rootMargin: '200px 0px',
      });
      observer.observe(videoContainerRef.value);
    };

    watch(videoContainerRef, (newContainer) => {
      if (newContainer) {
        setupObserver();
      }
    });

    onMounted(() => {
      if (!isRu.value) return;

      isMobile.value = window.innerWidth < 1024;
      if (videoContainerRef.value) {
        setupObserver();
      }
    });

    onBeforeUnmount(() => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    });

    return {
      isRu,
      isMobile,
      isPlaying,
      videoRef,
      videoContainerRef,
      carouselSettings,
      togglePlay,
    };
  },
});
